import {Controller} from "@hotwired/stimulus"

class FlashController extends Controller {
  static targets = ["alert"]

  alertTargetConnected(element) {
    if (element.querySelector("a, form")) {
      setTimeout(() => element.remove(), 8000)
    } else {
      setTimeout(() => element.remove(), 4000)
    }
  }

  add_message(message, type = "notice") {
    const alert = document.createElement("div")
    alert.className = `alert ${type}`
    alert.dataset.flashTarget = "alert"
    alert.innerHTML = message
    this.element.appendChild(alert)
  }
}

export default FlashController
